<div class="chips-container">
  @for (chip of chips(); track chip) {
    <span class="chip">{{ chip }}</span>
  }
</div>
